module.exports = __webpack_public_path__ + "img/shield-tick.96a9c8a2.png";